import { PurchaseOrderDetailPage } from "@/features/purchase-order/pages/PurchaseOrderDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/admin/purchase-order/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["purchase_order.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PurchaseOrderDetailPage,
  validateSearch: z.object({
    action: z.enum(["close"]).optional(),
  }),
});
